import React from 'react';

const Backdrop = ({ onClick }) => (
  <div
    onClick={onClick}
    className="fixed inset-0 bg-black/30 z-40"
    role="presentation"
  />
);

const RightSidebar = ({ open, onClose, title, children, width = 420, minWidth = 420 }) => {
  const [sidebarWidth, setSidebarWidth] = React.useState(width);
  const [isResizing, setIsResizing] = React.useState(false);

  React.useEffect(() => {
    setSidebarWidth(width);
  }, [width]);

  const onMouseDown = (e) => {
    e.preventDefault();
    setIsResizing(true);
    const startX = e.clientX;
    const startWidth = sidebarWidth;

    const onMouseMove = (ev) => {
      const deltaX = startX - ev.clientX; // dragging left increases width
      const newWidth = Math.max(minWidth, startWidth + deltaX);
      setSidebarWidth(newWidth);
    };

    const onMouseUp = () => {
      setIsResizing(false);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  return (
    <>
      {open ? <Backdrop onClick={onClose} /> : null}
      <div
        className={`fixed top-0 right-0 bg-white shadow-xl border-l border-gray-200 z-50 transition-transform duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'
          }`}
        style={{ width: sidebarWidth, height: '100vh' }}
      >
        {/* Resize handle */}
        <div
          onMouseDown={onMouseDown}
          className={`absolute left-0 top-0 h-full w-1 cursor-col-resize ${isResizing ? 'bg-blue-300' : 'bg-transparent'}`}
          title="Arrastrar para cambiar el ancho"
        />
        {children}
      </div>
    </>
  );
};

export default RightSidebar;


